export default "__VITE_ASSET__DXgcEAKm__"